import cn from "classnames"

import styles from "./InkTag.module.scss"

import type { InkTagProps } from "."

export const InkTag = (props: InkTagProps) => {
  const { color, dot, size, className } = props
  const isDot = !!dot

  return (
    <div
      style={{
        backgroundColor: `var(--bg-color-ink-tag, ${color || "inherit"})`
      }}
      className={cn(
        styles.tag,
        {
          [styles.dot]: isDot,
          [styles.dotSm]: isDot && size === "small"
        },
        className
      )}
    />
  )
}
